export const FILL_IN_THE_GAP = "FILL_IN_THE_GAP";
export const MISSING_WORD = "MISSING_WORD";
export const UNNECESSARY_WORD = "UNNECESSARY_WORD";
